import React, { useContext, useState } from 'react'
import { GoogleMap, Marker, MarkerClusterer, InfoBox } from '@react-google-maps/api'
import '../MapContainer.scss'
import APDealerLocatorPin from '../../../images/AP/ap-dealerLocator-pin.svg'
import APActiveDealerLocatorPin from '../../../images/AP/ap-active-dealerLocator-pin.svg'
import APHoverDealerLocatorPin from '../../../images/AP/ap-hover-dealerLocator-pin.svg'
import clusterIconAP from '../../../images/AP/ap-clustorDealersLocator-pin.svg'
import { dealersPerPageContext } from '../context'
import { isMobile } from '../../../helpers/helpers'
import CONSTANTS from '../../../Constants'
import { Button } from '../../Forms/Forms'
import { useDispatch } from 'react-redux'
import { setDealerDetails } from '../../../redux-files/actions/action'
const google = window.google;
const MyMap = ({
    isFullMap,
    dealersList,
    mapZoom = 6,
    mapLocation,
    mapStylesProps = {
        height: "472px",
        maxWidth: "1280px",
        margin: "auto"
    } }) => {
    const [map, setMap] = useState(null)
    const { MouseEnterDealerBlock, MouseLeaveDealerBlock, onDelaerClikced } = useContext(dealersPerPageContext)
    let _marker = new Object({
        icon: APDealerLocatorPin,
        iconActive: APActiveDealerLocatorPin,
        iconHover: APHoverDealerLocatorPin,
        iconCluster: clusterIconAP,
        size: (google.maps ? new google.maps.Size(80, 80) : false),
        scaledSize: (google.maps ? new google.maps.Size(80, 80) : false),
        origin: (google.maps ? new google.maps.Point(0, 0) : false)
    });

    const mapStyles = !isMobile() ? {
        height: "632px",
        maxWidth: "1280px",
        margin: "auto"
    } : mapStylesProps;
    // const mapStylesMobile = {
    //     height: "472px",
    //     maxWidth: "1280px",
    //     margin: "auto"
    // };

    const defaultCenter = {
        lat: mapLocation.lat || Number(window.siteConfig.defaultCountryGeo.lat),
        lng: mapLocation.lng || Number(window.siteConfig.defaultCountryGeo.lng)
    }

    const onUnmount = React.useCallback(function callback(map) {
        console.log('onUnmount')
        setMap(null)
    }, [])
    const setDealerIcon = (dealer) => {
        if (dealer.IsHover && !dealer.isClicked) {
            return new Object({
                url: _marker.iconHover,
                size: _marker.size,
                scaledSize: _marker.scaledSize,
                origin: _marker.origin
            })
        }
        else if (dealer.isClicked) {
            return new Object({
                url: _marker.iconActive,
                size: _marker.size,
                scaledSize: _marker.scaledSize,
                origin: _marker.origin
            })
        }
        else {
            return new Object({
                url: _marker.icon,
                size: _marker.size,
                scaledSize: _marker.scaledSize,
                origin: _marker.origin
            })
        }
    }

    const handleMarkerClick = (dealer) => {
        onDelaerClikced(dealer.DealerId)
        if (isFullMap) {
            if (map) {
                map.panTo(new google.maps.LatLng(Number(dealer.Latitude), Number(dealer.Longitude)))
            }
        }

    }

    return (
        <>
            <div>
                <GoogleMap
                    mapContainerStyle={mapStyles}
                    // zoom={mapZoom}
                    center={defaultCenter}
                    onLoad={map => {
                        map.setZoom(mapZoom)
                        setMap(map)
                    }}
                    onUnmount={onUnmount}
                    options={{ mapTypeControl: false, streetViewControl: false, }}
                >
                    <MarkerClusterer
                        averageCenter
                        enableRetinaIcons
                        gridSize={80}
                        maxZoom={10}
                        styles={[{ textColor: '#fff', fontFamily: 'Peugeot', textSize: 11, height: 120, url: _marker.iconCluster, width: 120, left: -1, lineHeight: 90 }]}
                        clusterClass='cluster-container'
                    >

                        {clusterer => dealersList.map((dealer, key) => {
                            return <Marker
                                clusterer={clusterer}
                                position={{ lat: Number(dealer.Latitude), lng: Number(dealer.Longitude) }}
                                // title={dealer.Name}
                                options={{ optimized: false }}
                                icon={setDealerIcon(dealer)}
                                key={dealer.DealerId}
                                onMouseOver={() => !isFullMap && MouseEnterDealerBlock(dealer.DealerId)}
                                onMouseOut={() => !isFullMap && MouseLeaveDealerBlock()}
                                onClick={() => handleMarkerClick(dealer)}
                            >
                                {dealer.isClicked && isFullMap && <InfoBoxRender dealer={dealer} />}
                            </Marker>

                        }
                        )}
                    </MarkerClusterer>
                </GoogleMap>
            </div>
        </>
    )
}
const InfoBoxRender = ({ dealer }) => {
    const dispatch = useDispatch()
    console.log(dealer.Name)
    const handleDealerChoosen = () => {
        dispatch(setDealerDetails({
            iD: dealer.DealerId,
            geoID: dealer.GeoId,
            name: dealer.Name,
            adress: dealer.Address,
            city: dealer.City,
            LCV: dealer.LCV,
            PC: dealer.PC,
            zip: dealer.ZipCode,
            listPremiumServices: dealer.ListeIdSP,
            position: { lat: Number(dealer.Latitude), lng: Number(dealer.Longitude) },
            SelfReception: dealer.SelfReception,
            editDealer: false
        }))
    }
    return (
        <InfoBox
            options={{
                closeBoxURL: '',
                enableEventPropagation: true,
                pixelOffset: new google.maps.Size(-130, -295),
                disableAutoPan: true,
                // maxWidth: 0,
                boxStyle: {
                    padding: '0px 0px 0px 0px',
                    width: '260px',
                    // height: 'auto',
                    // bottom: '0px'
                }
            }}
            position={{ lat: Number(dealer.Latitude), lng: Number(dealer.Longitude) }}
        >

            <div className='dealerInfoBox'>
                <h3 className='dealer-name'>{dealer.Name}</h3>

                <div className='dealer-distance'>
                    <i className='icons location-icon' />
                    <p> {dealer.Distance} {CONSTANTS.LABELS.vehicule_step2_km2} </p>
                </div>
                <p className='dealer-adress'>
                    {dealer.Address} <br />
                    {dealer.ZipCode}  {dealer.City}
                </p>
                {true && <div className='dealer-service'>
                    {(dealer.LCV || dealer.PC) && <i className='icons info-icon' />}
                    <div>
                        {(dealer.PC && !dealer.LCV) && <p>{CONSTANTS.LABELS.dealer_locator_filter_pc_descriptive}</p> /*the dealer do only particular vehicles*/}
                        {(dealer.LCV && !dealer.PC) && <p>{CONSTANTS.LABELS.dealer_locator_filter_lcv_descriptive}</p>/*the dealer do only utilitaire vehicles*/}
                        {(dealer.LCV && dealer.PC) && <p>{CONSTANTS.LABELS.dealer_locator_filter_pc_lvc_descriptive}</p> /*the dealer do both particular & utilitaire vehicles*/}
                    </div>

                </div>}
                <Button
                    isDisabled={false}
                    handlClick={handleDealerChoosen}
                >
                    {CONSTANTS.LABELS.dealer_locator_mapcta}
                </Button>
            </div>
        </InfoBox>
    );
}

export default MyMap;